import { useAtomValue } from 'jotai';
import { RendererType } from '../data-models/field-definition';
import { dealTodosState } from '../pages/DealFlow2/state/DealboardDataState';
import { createFormField, IFormFieldFreeLabelsMeta } from '../view-models/form.view-model';
import { FieldSettings } from './CommonFields';

export function useDealTodoField({
  key,
  label = key,
  required = false,
  disabled = false,
  maxTags = -1,
}: FieldSettings & Pick<IFormFieldFreeLabelsMeta, 'maxTags'>) {
  const todos = useAtomValue(dealTodosState);

  return createFormField<IFormFieldFreeLabelsMeta>({
    key,
    label,
    required,
    disabled,
    renderer: RendererType.freeLabels,
    rendererMeta: {
      maxTags,
      values: todos.map((todo) => {
        return {
          value: todo.name,
          displayName: todo.name,
        };
      }),
    },
  });
}
